import axios from "axios";
import { joinURLs } from "../utils/urlUtil";
import { getHeadersConfig } from "../utils/config";
import ErrorHandler from "../utils/ErrorHandler";
import { CampaignsResponseDto, ClinkResponseDto, ResponseStatus } from "../utils/types";

let getCampaignsAbortController = new AbortController();

export const Campaigns = {
  getCampaignsByAppId: async (appId:string, setCampaignsResponseDto:((campaignsResponseDto:CampaignsResponseDto) => void)) => {
    if (getCampaignsAbortController) getCampaignsAbortController.abort();
    getCampaignsAbortController = new AbortController();
  
    const url = joinURLs("admin/campaigns/query", process.env.REACT_APP_JUPITER_API_BASE_URL);
    const params = {
      "appid": appId,
      "returnStats": true,
      "returnCampaigns": true,
      "returnClinks": true,
      "includeNonMatchingCampaigns": true,
      "useExpandedSearchQuery": true,
      "formattedOptimizations": true
    };
  
    const responseDto:CampaignsResponseDto = {
      status: ResponseStatus.LOADING, 
      error: null,
      campaigns: [],
      unconfiguredCampaigns: [],
      clinks: []
    };
    setCampaignsResponseDto(responseDto);

    try {
      const response:any = await axios.get(url, {...getHeadersConfig(), params, signal: getCampaignsAbortController.signal });
      const responseDto : CampaignsResponseDto = {
        status : ResponseStatus.OK, 
        error : null,
        campaigns : [],
        unconfiguredCampaigns: [],
        clinks : []
      };

      if (response.data.apps.length) {
        responseDto.campaigns = response.data.apps[0].campaigns;
        responseDto.campaigns.forEach((campaign) => campaign.added = false);
        responseDto.clinks = response.data.apps[0].clinks;
        responseDto.campaigns.sort((c1, c2) => c1.status > c2.status ? 1 : -1)
      }
      setCampaignsResponseDto(responseDto);

    } catch (error:any) {
      // handle error

      if (!axios.isCancel(error)) {
        const isLoggedOut:boolean = ErrorHandler.handleLoggedOutError(error);
        if (!isLoggedOut){
          const responseDto: CampaignsResponseDto = {
            status: ResponseStatus.ERROR, 
            error: error?.response?.data?.errorMessage,           
            campaigns: [],
            unconfiguredCampaigns: [],
            clinks: []
          };
          setCampaignsResponseDto(responseDto);
        }
      }
    }
  },

  getCampaignsForAppID: async (clinkResponseDto:ClinkResponseDto, setCampaignsResponseDto:((campaignsResponseDto:CampaignsResponseDto) => void)) => {
    if (getCampaignsAbortController) getCampaignsAbortController.abort();
    getCampaignsAbortController = new AbortController();

    const url = joinURLs("admin/campaigns/query", process.env.REACT_APP_JUPITER_API_BASE_URL);
    const params = {
      "appid": clinkResponseDto.clink.appId,
      "method": "campaignsForAppID",
      "returnCampaigns": true,
      "formattedOptimizations": true
    };

    const responseDto:CampaignsResponseDto = {
      status: ResponseStatus.LOADING, 
      error: null,
      campaigns: [],
      unconfiguredCampaigns: [],
      clinks: []
    };
    setCampaignsResponseDto(responseDto);

    try {

      const response:any = await axios.get(url, {...getHeadersConfig(), params, signal: getCampaignsAbortController.signal });
      const responseDto:CampaignsResponseDto = {
        status: ResponseStatus.OK, 
        error: null,
        campaigns:[],
        unconfiguredCampaigns:[],
        clinks:[]
      };

      if (response.data.apps.length) {
        responseDto.campaigns = response.data.apps[0].campaigns;
        responseDto.campaigns.forEach((campaign) => campaign.added = false);
        responseDto.campaigns.sort((c1, c2) => c1.status > c2.status ? 1 : -1)
        clinkResponseDto.clink.campaigns.forEach((campaign) => {
          let unconfigured = true;

          responseDto.campaigns.forEach((possible_campaign) => {
            if (possible_campaign.supplySource === campaign.source && possible_campaign.campaignID === campaign.campaign_id) {
              if (clinkResponseDto.clink.countries.find((country) => country.id === possible_campaign.countries)) {
                possible_campaign.added = true;
                unconfigured = false;
              }
            }
          });
          if (unconfigured) {
            campaign.added = true;
            responseDto.unconfiguredCampaigns.push(campaign);
          }
        });
      }
      setCampaignsResponseDto(responseDto);
    } catch (error:any) {
      // handle error

      if (!axios.isCancel(error)) {
        const isLoggedOut:boolean = ErrorHandler.handleLoggedOutError(error);
        if (!isLoggedOut){
          const responseDto : CampaignsResponseDto = {
            status: ResponseStatus.ERROR, 
            error: error?.response?.data?.errorMessage,           
            campaigns: [],
            unconfiguredCampaigns: [],
            clinks: []
          };
          setCampaignsResponseDto(responseDto);
        }
      }
    }
  }
}
